import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import useInitPurchase from '@hooks/useInitPurchase';
import FormLayout from '@/containers/formLayout';
import FormBafClientFake from '@/components/fakes/formPagesFake/formTvClientFake';
import { SEGMENT, BUBBLE_TEXTS } from '@/constants/constant';
import { FORM_ID, TRANSACTION_TYPE } from '@/constants/pages/tv';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';
import { actions } from '@/reducers/form-tv-reducer';
import Title, { TITLE_SIZE } from '@/components/title';
import { capitalizeWords, sendTaggingInfo } from '@/utils/common';
import ClientPersonalData from '@/containers/clientPersonalData';

const TvClientForm = ({ segment = SEGMENT.particulares }) => {
  const dispatch = useDispatch();
  const shoppingCart = useSelector((state) => state.formTv.shoppingCart);
  const loadingShoppingCart = useSelector(
    (state) => state.formTv.loadingShoppingCart
  );
  const checkout = useSelector((state) => state.formTv.checkout);
  const customerInfo = useSelector((state) => state.formTv.customerInfo);
  const [showErrorBubble, setShowErrorBubble] = useState(false);
  const [funnelTaggingInfoSent, setFunnelTaggingInfoSent] = useState(false);

  const { handleSubmit, control, setValue } = useForm({
    mode: 'onTouched',
  });
  const onSubmit = async (formData) => {
    setShowErrorBubble(false);
    const deviceKind = getDeviceKindDependsOnViewPort();
    dispatch(actions.checkout({ formData, deviceKind }));
  };
  const onError = (formErrors) => {
    if (Object.keys(formErrors).length > 1) {
      setShowErrorBubble(true);
      if ('scrollTo' in window && typeof window.scrollTo === 'function') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant',
        });
      }
    } else if (Object.keys(formErrors).length === 1) {
      setShowErrorBubble(false);
      const scrollElement = document.getElementById(Object.keys(formErrors)[0]);
      if (scrollElement) {
        scrollElement.scrollIntoView({ behavior: 'instant' });
      }
    }
  };
  const { setSegment, setFirstZone, initPurchase } = actions;
  useInitPurchase({
    segment,
    initPurchase,
    setSegment,
    setZone: setFirstZone,
    loaded: !!shoppingCart,
  });

  useEffect(() => {
    if (
      shoppingCart &&
      !funnelTaggingInfoSent &&
      window.grecaptcha &&
      window.grecaptcha.enterprise
    ) {
      window.grecaptcha.enterprise.ready(() => {
        const { telcoProductName, totalRecurringPrice } = {
          ...shoppingCart,
        };
        const { finalPrice } = {
          ...totalRecurringPrice,
        };
        sendTaggingInfo(
          {
            product: telcoProductName,
            price: finalPrice,
            funnelPurchaseMode: '',
            userType: '',
            funnelStepName: 'formulario',
            transactionType: TRANSACTION_TYPE,
            funnelFlowName: 'movistar-layer',
          },
          '',
          'movistar_layer_google_ads'
        );
        setFunnelTaggingInfoSent(true);
      });
    }
  }, [shoppingCart]);
  return (
    <>
      <Head>
        <script
          async
          src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID}`}
        />
      </Head>
      <FormLayout
        pageId={FORM_ID.GP}
        onSubmit={handleSubmit(onSubmit, onError)}
        control={control}
        showErrorBubble={showErrorBubble}
        textBubble={BUBBLE_TEXTS.BUBBLE_ERROR_TEXT}
        loaded={!!shoppingCart}
        shoppingCart={shoppingCart}
        loadingShoppingCart={loadingShoppingCart}
        loadingButtonShoppingCart={checkout}
        formFake={<FormBafClientFake />}
        columnForm
      >
        <Title
          text={`Hola${
            customerInfo?.customerName
              ? ` ${capitalizeWords(customerInfo?.customerName)}`
              : ''
          }, completa tu pedido`}
          size={TITLE_SIZE.TITLE5}
        />
        <ClientPersonalData
          payment="En tu factura"
          control={control}
          setValue={setValue}
          contactEmail={customerInfo?.contactMedia?.contactEmail}
          contactPhone={customerInfo?.contactMedia?.contactPhone}
          shouldHavePersonalData={false}
        />
      </FormLayout>
    </>
  );
};
export default TvClientForm;
